export const dropdownSpring = { type: 'spring', stiffness: 380, damping: 30 };

export const dropdownPanelVariants = {
  hidden: { opacity: 0, scale: 0.92, y: -8 },
  visible: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.96, y: -4 },
};

export const dropdownPanelVariantsUp = {
  hidden: { opacity: 0, scale: 0.92, y: 8 },
  visible: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.96, y: 4 },
};

export function dropdownPanelVariantsForPlacement(placement = 'bottom') {
  return placement === 'top' ? dropdownPanelVariantsUp : dropdownPanelVariants;
}

export const dropdownItemVariants = {
  hidden: { opacity: 0, y: 6 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 420, damping: 32, delay: index * 0.035 },
  }),
};

export function dropdownTransition(reducedMotion) {
  return reducedMotion ? { duration: 0.01 } : dropdownSpring;
}
